<template>
  <div class="division">
    <div class="flex space-between">
      <h1 class="division__title">Подразделения <span v-if="total" class="division__count">{{total}}</span> </h1>
      <VButtonNew  @click="add" class="division__create" label="Новое подразделение" style-type="link">
        <template #iconLeft>
          <IconsPlus icon-size="20px" />
        </template>
      </VButtonNew>
    </div>

    <div class="division__title-name">Название</div>
    <div class="division__wrapper">
      <div v-if="!skeleton"  v-for="item in divisionsData?.data" class="division__main">
        <div  class="v__main-list">
          <DivisionContent
              :key="item.id"
              :data="item"
              :expanded-items="expandedItems"
              @toggle-expand="handleToggleExpand"
              @edit="handleEdit"
              @delete="handleDelete"
              @add="handleAdd"
              no-divider
          />
        </div>

      </div>
      <div v-if="skeleton" class="division__block-option">
        <VSkeleton class="division__block-option-block" variants="SETTINGS_REASONS" />
      </div>
      <div class="division__no-content" v-if="!skeleton && !divisionsData?.data?.length">
        <VNoContent
            v-if="!search"
            title="Список подразделений пуст"
        />
      </div>
    </div>
    <ModalWindow
        class="division__modal-poups"
        :showModalWithOverflow="showModalWindow"
        v-show="showModalWindow"
        @close="showModalWindow = false"
    >
      <VModalWrapper hidden-btn :title="divisionsDialogTitle" @close="showModalWindow = false" width="477px" @apply="apply">
        <VCustomInput
            class="division__input"
            placeholder="Название*"
            v-model="dataForm.name"
        />
        <VSelect placeholder="Родительское подразделение"
                 :options="divisionOption"
                 v-model="dataForm.parent_id"
                 class="w-full "/>
        <VButtonNew
            :label="divisionsDialogTitle === 'Новое подразделение'? 'Добавить': 'Сохранить'"
            class="w-full"
            @click="apply"
        />

        <VButtonNew
            label="Отменить"
            style-type="grey"
            class="w-full"
            @click="cancel"
        />
      </VModalWrapper>
    </ModalWindow>
  </div>
</template>

<script setup>
import {ref, onMounted} from "vue";

import divisions from "@/api/divisions";
import DivisionContent from "@/components/Settings/DivisionContent.vue";
import VSkeleton from "@/components/UI/VSkeleton/index.vue";
import IconsPlus from "@/components/Icons/Plus.vue";
import VButtonNew from "@/components/UI/VButtonNew/index.vue";
import VModalWrapper from "@/components/UI/VModalWrapper.vue";
import VSelect from "@/components/UI/VSelect/index.vue";
const skeleton = ref(true)

const dataForm = ref({
  division_name: "",
  division_parent: "",
})

const divisionOption = ref([])

const showModalWindow = ref(false);
const currentItemId = ref(null);
const total = ref(0);
const search = ref("");
const add = () => {
  dataForm.value = {
    name: "",
    parent_id: "",
  }
  showModalWindow.value = true;
  divisionsDialogTitle.value = "Новое подразделение"
};

const apply = async () => {
  if (divisionsDialogTitle.value === 'Новое подразделение') {
    await divisions.addDivisions(dataForm.value)
  } else {
    await divisions.editDivisions(dataForm.value, currentItemId.value)
  }
  showModalWindow.value = false;
  await getDivision();
}

const cancel = () => {
  //TODO Логика
  showModalWindow.value = false;
}
const divisionsDialogTitle = ref('Новое подразделение')
const divisionsData = ref([]);

const expandedItems = ref([]);

// Функция для переключения состояния развертывания
const handleToggleExpand = (itemId) => {
  if(expandedItems.value.includes(itemId)) {
    console.log('123')
    expandedItems.value = expandedItems.value.filter(item => item !== itemId);
  } else {
    expandedItems.value.push(itemId);
  }
};

const handleEdit = (item) => {
  dataForm.value = {
    name: item.name,
    parent_id: "",
  }
  currentItemId.value = item.id;
  showModalWindow.value = true
  divisionsDialogTitle.value = "Редактировать подразделение"
};

const handleDelete = async (item) => {
  await divisions.deleteDivisions(item.id)
  await getDivision();
};

const handleAdd = (parent) => {
  dataForm.value = {
    name: "",
    parent_id: parent.id,
  }
  showModalWindow.value = true;
  divisionsDialogTitle.value = "Новое подразделение"
};

function flattenArrayReduce(arr) {
  return arr.reduce((acc, item) => {
    acc.push(item);
    if (item.children && item.children.length > 0) {
      acc = acc.concat(flattenArrayReduce(item.children));
    }
    return acc;
  }, []);
}

const getDivision = async () => {
  skeleton.value = true;
  divisionsData.value = await divisions.getDivisions()
  divisionOption.value = flattenArrayReduce(divisionsData.value?.data)
  divisionOption.value = divisionOption.value?.map(item => {
    return {
      id: item.id,
      label: item.name,
    }
  })
  total.value = divisionOption.value?.length || 0;
  skeleton.value = false;
};
onMounted(async () => {
  await getDivision();
})

</script>

<style scoped lang="scss">
.division {
  width: 832px!important;

  &__no-content {
    width: 100%;
    height: calc(100vh - 543px);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__create {
    margin-top: 16px;
    font-weight: 500;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0;
    text-align: right;

  }

  &__title {
    margin-top: 28px;
    margin-bottom: 24px;
    font-weight: 700;
    font-size: 28px;
    line-height: 33.89px;
    letter-spacing: 0%;
    color: $dark;
  }

  &__count {
    font-weight: 700;
    font-size: 16px;
    color: $gray;
    line-height: 100%;
    letter-spacing: 0;
  }

  &__title-name {
    background-color: white;
    display: flex;
    align-items: center;
    padding-left: 20px;
    height: 40px;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0;
    color: $gray;
    border-radius: 12px;
    margin-bottom: 12px;
  }

  &__wrapper {
    column-gap: 32px;
    align-items: flex-start;
  }
  &__aside {
    padding: 12px;
    width: 256px;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-radius: 16px;
    flex-grow: 0;
  }
  &__aside-title {
    width: 232px;
    margin-top: 12px;
    margin-bottom: 12px;
    margin-left: 12px;
    font-weight: 600;
    font-size: 16px;
    line-height: 19.36px;
    letter-spacing: 0%;
    color: $dark;
  }
  &__aside-item {
    width: 232px;
    padding: 12px;
    font-weight: 400;
    font-size: 14px;
    line-height: 16.94px;
    letter-spacing: 0%;
    color: $dark;
    border-radius: 8px;
    cursor: pointer;

    &:not(:last-child) {
      margin-bottom: 4px;
    }
    &:hover {
      background-color: #f0f2f4;
    }

    &_active {
      background-color: #f0f2f4;
    }
  }
  &__main {
    width: 832px;
    padding-left: 24px;
    padding-right: 24px;
    margin-bottom: 8px;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-radius: 16px;
  }
  &__main-title {
    margin-bottom: 8px;
    font-weight: 500;
    font-size: 20px;
    line-height: 24.2px;
    letter-spacing: 0%;
    color: $dark;
  }
  &__main-description {
    max-width: 528px;
    margin-bottom: 16px;
    font-weight: 400;
    font-size: 14px;
    line-height: 16.94px;
    letter-spacing: 0%;

    color: $gray;
  }
  &__main-button {
    padding: 4px;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    background-color: transparent;
    margin-right: auto;
    outline: none;
    border: none;
    color: $blue;
    font-weight: 400;
    font-size: 14px;
    line-height: 16.94px;
    letter-spacing: 0%;
    text-align: right;
    cursor: pointer;
  }
  &__main-button-icon {
    margin-right: 4px;
  }
  &__item {
    display: flex;
    position: relative;
    width: 100%;
    column-gap: 16px;

    &:not(:last-child) {
      margin-bottom: 12px;
    }
  }
  &__item-content {
    padding: 15.5px 16px;
    background-color: #f4f5f7;
    border-radius: 8px;
    font-weight: 400;
    font-size: 14px;
    line-height: 16.94px;
    letter-spacing: 0%;
    flex: 1 1 calc(100% - 16px - 24px);
  }
  &__item-actions {
    width: 24px;
    height: 24px;
    flex: 1 1 24px;
    cursor: pointer;
  }

  &__item-actions-icon {
    display: block;
    margin-top: 12px;
  }
  &__actions-dropdown {
    position: absolute;
    right: 0px;
    bottom: -72px;
    z-index: +5;
    padding: 8px 12px;
    width: 174px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 2px 4px 24px 0px rgba(0, 0, 0, 0.12);
  }
  &__action-edit {
    display: flex;
    align-items: center;
    height: 32px;
    margin-bottom: 8px;
    column-gap: 4px;
    cursor: pointer;
  }
  &__action-delete {
    display: flex;
    align-items: center;
    height: 32px;
    column-gap: 4px;
    cursor: pointer;
  }
  &__modal-poups {
    &::v-deep(.modal__body) {
      width: auto;
      height: auto;
      border-radius: 16px;
    }
  }

  &__block-option-block {
    :deep(.card-content__el) {
      height: 64px;
      margin-right: 0;
      border-radius: 16px;
    }
  }

  &__input {
    width: 100%;
  }
}
</style>
